import React, { Suspense, lazy } from "react";
import { Routes as Switch, Route } from "react-router-dom";

import Header from "components/header/Header";
import Footer from "components/footer/Footer";

// const Home = lazy(() => import("pages/home"));
// const FAQs = lazy(() => import("pages/faqs"));
const Staking = lazy(() => import("pages/staking"));
// const Bridge = lazy(() => import("pages/bridge"));

const RoutesComponent = () => {
  return (
    <>
      <Header />
      <main>
        <Switch>
          <Route
            path="/"
            element={
              <Suspense>
                <Staking />
              </Suspense>
            }
          />
          {/* <Route
            path="/faqs"
            element={
              <Suspense>
                <FAQs />
              </Suspense>
            }
          /> */}
          {/* <Route
            path="/staking"
            element={
              <Suspense>
                <Staking />
              </Suspense>
            }
          /> */}
          {/* <Route
            path="/swap"
            element={
              <Suspense>
                <Stake />
              </Suspense>
            }
          /> */}
          {/* <Route
            path="/bridge"
            element={
              <Suspense>
                <Bridge />
              </Suspense>
            }
          /> */}
        </Switch>
      </main>
      <Footer />
    </>
  );
};

export default RoutesComponent;
